module.exports = __webpack_public_path__ + "img/img_dns.3be16824.png";